import { render, staticRenderFns } from "./VanTaiKhachList.vue?vue&type=template&id=964a38fa"
import script from "./VanTaiKhachList.vue?vue&type=script&lang=js"
export * from "./VanTaiKhachList.vue?vue&type=script&lang=js"
import style0 from "./VanTaiKhachList.vue?vue&type=style&index=0&id=964a38fa&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports